import { nr } from '~/src/common/newRelic';

export const identifyUser = (currentUser: { id: string } | null) => {
  nr.setAttribute('userId', currentUser?.id || '');
};
